import React from 'react';
import '../styles/tavern-components.css';

export interface TavernSwitchProps {
  checked: boolean;
  /** Some, but not all, of the grouped options are on. Turning it on switches everything on. */
  mixed?: boolean;
  disabled?: boolean;
  /** Visible text next to the track. */
  label?: string;
  /** Accessible name when there is no visible label. */
  ariaLabel?: string;
  onChange: (checked: boolean) => void;
  className?: string;
}

/**
 * Tavern-styled on/off switch (44px touch target).
 *
 * @example
 * <TavernSwitch checked={enabled} ariaLabel="Отмена мероприятия" onChange={setEnabled} />
 */
export function TavernSwitch({
  checked,
  mixed = false,
  disabled = false,
  label,
  ariaLabel,
  onChange,
  className = '',
}: TavernSwitchProps) {
  return (
    <label className={`ttbSwitch ${className}`.trim()} data-mixed={mixed || undefined}>
      <input
        type="checkbox"
        role="switch"
        aria-checked={mixed ? 'mixed' : checked}
        aria-label={label ? undefined : ariaLabel}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className="ttbSwitchTrack" aria-hidden="true">
        <span className="ttbSwitchThumb" />
      </span>
      {label ? <span className="ttbSwitchLabel">{label}</span> : null}
    </label>
  );
}
